import { POLL_INTERVAL_MS } from './constants'
import { injectDoubanPortButton } from './modules/douban/injector'
import { injectLibbyPortButton } from './modules/libby/injector'
import { injectAmazonPortButton } from './modules/amazon/injector'
import { injectKoboPortButton } from './modules/kobo/injector'
import { injectReadmooPortButton } from './modules/readmoo/injector'
import { injectChilchilPortButton } from './modules/chilchil/injector'
import { injectPubuPortButton } from './modules/pubu/injector'
import { maybeAutofillStoryGraph } from './modules/storygraph/autofill'
import { maybeFallbackToOriginalTitleSearch } from './modules/storygraph/searchFallback'
import { injectStoryGraphShortcuts } from './modules/storygraph/shortcuts'
import { getUserOptions, registerOptionMenu } from './modules/settings'

function runStoryGraphFeatures (): void {
  injectStoryGraphShortcuts()
  maybeFallbackToOriginalTitleSearch()
  maybeAutofillStoryGraph()
}

function bootDouban (): void {
  injectDoubanPortButton()
  window.setInterval(injectDoubanPortButton, POLL_INTERVAL_MS)
}

function bootLibby (): void {
  injectLibbyPortButton()
  if (document.body) {
    const observer = new MutationObserver(injectLibbyPortButton)
    observer.observe(document.body, { childList: true, subtree: true })
  }
  window.setInterval(injectLibbyPortButton, POLL_INTERVAL_MS)
}

function bootAmazon (): void {
  injectAmazonPortButton()
  window.setInterval(injectAmazonPortButton, POLL_INTERVAL_MS)
}

function bootKobo (): void {
  injectKoboPortButton()
  window.setInterval(injectKoboPortButton, POLL_INTERVAL_MS)
}

function bootReadmoo (): void {
  injectReadmooPortButton()
  window.setInterval(injectReadmooPortButton, POLL_INTERVAL_MS)
}

function bootChilchil (): void {
  injectChilchilPortButton()
  window.setInterval(injectChilchilPortButton, POLL_INTERVAL_MS)
}

function bootPubu (): void {
  injectPubuPortButton()
  window.setInterval(injectPubuPortButton, POLL_INTERVAL_MS)
}

function bootStoryGraph (): void {
  runStoryGraphFeatures()

  if (!document.body) return

  const observer = new MutationObserver(runStoryGraphFeatures)
  observer.observe(document.body, { childList: true, subtree: true })

  window.setInterval(runStoryGraphFeatures, POLL_INTERVAL_MS)
}

(function main () {
  registerOptionMenu()
  const options = getUserOptions()

  const host = window.location.host
  if (host === 'book.douban.com') {
    if (!options.enableDouban) return
    bootDouban()
    return
  }

  if (host === 'libbyapp.com' || host.endsWith('.libbyapp.com')) {
    if (!options.enableLibby) return
    bootLibby()
    return
  }

  if (host === 'www.amazon.com' || host === 'amazon.com' || host.endsWith('.amazon.com') || host === 'www.amazon.co.jp' || host === 'amazon.co.jp' || host.endsWith('.amazon.co.jp')) {
    if (!options.enableAmazon) return
    bootAmazon()
    return
  }

  if (host === 'www.kobo.com' || host === 'kobo.com' || host.endsWith('.kobo.com')) {
    if (!options.enableKobo) return
    bootKobo()
    return
  }

  if (host === 'readmoo.com' || host === 'www.readmoo.com') {
    if (!options.enableReadmoo) return
    bootReadmoo()
    return
  }

  if (host === 'chil-chil.net' || host === 'www.chil-chil.net') {
    if (!options.enableChilchil) return
    bootChilchil()
    return
  }

  if (host === 'www.pubu.com.tw' || host === 'pubu.com.tw') {
    if (!options.enablePubu) return
    bootPubu()
    return
  }

  if (host === 'app.thestorygraph.com') {
    if (!options.enableStoryGraph) return
    bootStoryGraph()
  }
})()
